export default __webpack_public_path__ + "static/media/random1.674505c1.jpeg";